import { getFeatureFlagValue } from '@citrite/feature-flags';
import { FeatureFlag } from './featureFlags';
import { t } from './translate';
import { ProjectUserRole } from './types';
export const ShareFileProjectTemplateSolution = () => {
    return {
        template: { name: 'Enhanced project experience', value: 'workmgmttemplate' },
        tag: { name: 'system:project:template', value: 'work_management_template' },
        resourceType: 'sharefile:project',
        eventUrn: 'urn:drawer:template-pilet:open-template-drawer',
        footerButtonLabels: {
            buttonText: {
                en: t('AddOrUpdateProject.create'),
                es: t('AddOrUpdateProject.create'),
                de: t('AddOrUpdateProject.create'),
                fr: t('AddOrUpdateProject.create'),
                it: t('AddOrUpdateProject.create'),
                ja: t('AddOrUpdateProject.create'),
                nl: t('AddOrUpdateProject.create'),
                'pt-BR': t('AddOrUpdateProject.create'),
            },
            cancelButtonText: {
                en: t('AddOrUpdateProject.cancel'),
                es: t('AddOrUpdateProject.cancel'),
                de: t('AddOrUpdateProject.cancel'),
                fr: t('AddOrUpdateProject.cancel'),
                it: t('AddOrUpdateProject.cancel'),
                ja: t('AddOrUpdateProject.cancel'),
                nl: t('AddOrUpdateProject.cancel'),
                'pt-BR': t('AddOrUpdateProject.cancel'),
            },
        },
    };
};
export const shouldDisableLegacyRoles = () => { var _a; return (_a = getFeatureFlagValue(FeatureFlag.DisableLegacyRoles)) !== null && _a !== void 0 ? _a : false; };
export const mockUserRole = shouldDisableLegacyRoles()
    ? ProjectUserRole.Guest
    : ProjectUserRole.Owner;
//# sourceMappingURL=constants.js.map